function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import Location from '../utils/model';
import defaultPropTypes from '../utils/prop-types';
import { renderComponents } from '../utils/convenience';

var Search = /*#__PURE__*/function (_React$Component) {
  _inherits(Search, _React$Component);

  var _super = _createSuper(Search);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _super.call(this, props);
    _this.google = window.google; // eslint-disable-line

    _this.PlacesService = _this.google && _this.google.maps.places ? _this.google.maps.places.PlacesService : null; // eslint-disable-line

    _this.PlacesServiceStatus = _this.google && _this.google.maps.places ? _this.google.maps.places.PlacesServiceStatus : null; // eslint-disable-line

    _this.SearchBox = _this.google && _this.google.maps.places ? _this.google.maps.places.SearchBox : null; // eslint-disable-line

    _this.node = /*#__PURE__*/React.createRef();
    _this.onPlacesChanged = _this.onPlacesChanged.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleKey = _this.handleKey.bind(_assertThisInitialized(_this));
    _this.handleSearchClick = _this.handleSearchClick.bind(_assertThisInitialized(_this));
    _this.state = {
      noPlacesFound: false,
      searchValue: _this.props.defaultSearchValue
    };
    return _this;
  }

  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.SearchBox) {
        this.searchBox = new this.SearchBox(this.node.current);
        this.searchBox.addListener('places_changed', this.onPlacesChanged);
      }

      if (this.PlacesService) {
        this.placesService = new this.PlacesService(this.node.current);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // https://developers.google.com/maps/documentation/javascript/events#removing
      if (this.searchBox) {
        this.google.maps.event.clearInstanceListeners(this.searchBox);
      }

      try {
        // Removing google create container for auto complete
        var pacContainer = document.querySelector('.pac-container');
        pacContainer.parentNode.removeChild(pacContainer);
      } catch (err) {// Fail silently because there is no .pac-container
      }
    }
    /**
     * Google Places places_changed API callback
     * Handles when the user selects a place from the autocomplete dropdown
     * or simply presses Enter.
     */

  }, {
    key: "onPlacesChanged",
    value: function onPlacesChanged() {
      var places = this.searchBox.getPlaces();
      var place = places.length > 0 ? places[0] : null;
      var searchValue = this.state.searchValue;

      if (place) {
        searchValue = place.name;
        this.props.onSearchLocation(Location.fromGooglePlace(place));
      }

      this.setState({
        noPlacesFound: !place,
        searchValue: searchValue
      });
    }
    /**
     * Handles search inputfield change and updates the state
     */

  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        searchValue: e.target.value
      });
    }
    /**
     * Handles submit with Enter key
     * No need to do anything other than preventing the form submitting,
     * since everyting is handled in onPlacesChanged
     */

  }, {
    key: "handleKey",
    value: function handleKey(e) {
      if (e.keyCode === 13) {
        // remove focus to hide mobile keyboard
        this.node.current.blur(); // Prevent page form submitting

        var form = document.querySelector('form');
        form.submit = null;
        form.onsubmit = null;
        e.preventDefault();
        window.DGS.Event.getInstance().trigger('trackLocationsSearchPhrase', this.state.searchValue);
      }
    }
    /**
     * Handles search when clicking the search icon.
     * Queries Google Places API and selects the first result
     */

  }, {
    key: "handleSearchClick",
    value: function handleSearchClick() {
      var _this2 = this;

      this.placesService.findPlaceFromQuery({
        query: this.state.searchValue,
        locationBias: 'IP_BIAS',
        fields: ['name', 'formatted_address', 'geometry']
      }, function (places) {
        var place = places && places.length > 0 ? places[0] : null;
        var searchValue = place ? place.name : _this2.state.searchValue;

        _this2.setState({
          noPlacesFound: !place,
          searchValue: searchValue
        });

        if (place) {
          _this2.props.onSearchLocation(Location.fromGooglePlace(place));
        }
      });
      window.DGS.Event.getInstance().trigger('trackLocationsSearchPhrase', this.state.searchValue);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-search"
      }, renderComponents('header', this.props.header, this.props), this.SearchBox && /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("input", {
        ref: this.node,
        type: "text",
        value: this.state.searchValue,
        onChange: this.handleChange,
        onKeyDown: this.handleKey,
        placeholder: this.props.settings.dictionary.searchFieldPlaceholder
      }), /*#__PURE__*/React.createElement("div", {
        className: "search-icon",
        onClick: this.handleSearchClick,
        role: "presentation"
      }), this.state.noPlacesFound && /*#__PURE__*/React.createElement("div", {
        className: "no-results"
      }, "No results found")), !this.SearchBox && /*#__PURE__*/React.createElement("div", null, "Include maps.googleapis.com/maps/api/js on the page"), renderComponents('footer', this.props.footer, this.props));
    }
  }]);

  return Search;
}(React.Component);

Search.propTypes = {
  onSearchLocation: defaultPropTypes.func,
  header: defaultPropTypes.components,
  footer: defaultPropTypes.components,
  settings: defaultPropTypes.settings,
  defaultSearchValue: defaultPropTypes.string
};
Search.defaultProps = {
  onSearchLocation: defaultPropTypes.defaultOnSearchLocation,
  header: defaultPropTypes.defaultComponents(),
  footer: defaultPropTypes.defaultComponents(),
  settings: defaultPropTypes.defaultSettings,
  defaultSearchValue: ''
};
export default Search;